export const PROFILE_ROUTING = {
  data: 'data',
};
